/**
 * Wrapper "Engajamento" — título + card de retenção do aluno.
 *
 * Apenas envelopa o StudentRetentionCard (que cuida de KPIs,
 * sparkline e atalho WhatsApp). Só rende o título + card.
 *
 * Props:
 *   - studentId: id do aluno (passado direto pro card)
 *   - studentName / studentPhone: usados pelo card pra montar mensagem
 *     do WhatsApp.
 *
 * Quando NÃO usar: se quiser o card sem o título "Engajamento", use
 * StudentRetentionCard direto.
 */

import { memo } from 'react';
import { Text } from 'react-native';
import { StudentRetentionCard } from '@/components/StudentRetentionCard';
import { sharedStyles } from './styles';

interface Props {
  studentId: string;
  studentName: string | null;
  studentPhone: string | null;
}

function EngagementSectionImpl({ studentId, studentName, studentPhone }: Props) {
  return (
    <>
      <Text style={sharedStyles.sectionTitle}>Engajamento</Text>
      <StudentRetentionCard
        studentId={studentId}
        studentName={studentName}
        studentPhone={studentPhone}
      />
    </>
  );
}

export const EngagementSection = memo(EngagementSectionImpl);
